import { activeServiceRequestChoices } from 'utils/DICTIONARY';

export default function getAllowedStatusMapForDelete() {
  const inProgressStatuses = activeServiceRequestChoices();
  return inProgressStatuses.reduce((acc, status) => {
    acc[status] = true;
    return acc;
  }, {});
}
